import {PROGRAM_URL} from "../../helpers/api.routes";
import {requests} from "../../helpers/api.services";

export const AdminProgramService = {
    get: () => requests.get(PROGRAM_URL),
    create: (params: any)=> requests.post(PROGRAM_URL, params, true),
    delete: (id: number) => requests.delete(`${PROGRAM_URL}/schema/${id}`),
    updatePosition: (ids: number[])=> requests.patch(PROGRAM_URL, {ids})
}